
import React, { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import { BenefitsList } from './benefits';
import { Benefit } from '@/lib/supabase/products';
import { Card } from '@/components/ui/card';
import { Plus } from 'lucide-react';

interface ProductBenefitsProps {
  benefits: Benefit[];
  setBenefits: (benefits: Benefit[]) => void;
}

const ProductBenefits = ({ benefits, setBenefits }: ProductBenefitsProps) => {
  const [isExpanded, setIsExpanded] = useState(true);

  const addNewBenefit = () => {
    const newBenefit = {
      id: crypto.randomUUID(),
      title: '',
      description: '',
      icon: 'star',
      visible: true,
    };
    setBenefits([...benefits, newBenefit]);
  };

  const updateBenefit = (id: string, field: keyof Benefit, value: any) => {
    setBenefits(
      benefits.map((benefit) =>
        benefit.id === id ? { ...benefit, [field]: value } : benefit
      )
    );
  };

  const removeBenefit = (id: string) => {
    setBenefits(benefits.filter((benefit) => benefit.id !== id));
  };

  const toggleVisibility = (id: string) => {
    setBenefits(
      benefits.map((benefit) =>
        benefit.id === id 
          ? { ...benefit, visible: benefit.visible === false ? true : false } 
          : benefit
      )
    );
  };

  return (
    <div className="bg-white dark:bg-[#1a1a2e] border border-gray-200 dark:border-gray-800 rounded-lg shadow-sm">
      <div className="p-4 sm:p-6">
        <Collapsible
          open={isExpanded}
          onOpenChange={setIsExpanded}
          className="space-y-4"
        >
          <div className="flex items-center justify-between">
            <h3 className="text-lg font-medium text-gray-900 dark:text-white">Bénéfices du produit</h3>
            <CollapsibleTrigger asChild>
              <Button variant="ghost" size="sm" className="text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800">
                {isExpanded ? "Masquer" : "Afficher"}
              </Button>
            </CollapsibleTrigger>
          </div>

          <CollapsibleContent className="space-y-4">
            <BenefitsList
              benefits={benefits}
              updateBenefit={updateBenefit}
              removeBenefit={removeBenefit}
              toggleVisibility={toggleVisibility}
              addNewBenefit={addNewBenefit}
            />
          </CollapsibleContent>
        </Collapsible>
      </div>
    </div>
  );
};

export default ProductBenefits;
